(() => {
  const initHeader = (root) => {
    if (!root || root.dataset.tlInit === 'true') return;
    root.dataset.tlInit = 'true';

    const drawer = root.querySelector('[data-tl-drawer]');
    const search = root.querySelector('[data-tl-search]');
    const cartBubble = root.querySelector('[data-tl-cart-bubble]');
    const cartCount = root.querySelector('[data-tl-cart-count]');

    root.querySelectorAll('[data-tl-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-tl-open');
        if (target === 'drawer' && drawer) drawer.classList.add('is-open');
        if (target === 'search' && search) search.classList.add('is-open');
      });
    });

    root.querySelectorAll('[data-tl-close]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-tl-close');
        if (target === 'drawer' && drawer) drawer.classList.remove('is-open');
        if (target === 'search' && search) search.classList.remove('is-open');
      });
    });

    if (cartBubble && cartCount) {
      const getCurrentCount = () => {
        const count = parseInt(cartCount.textContent || '0', 10);
        return Number.isFinite(count) && count > 0 ? count : 0;
      };

      const renderCartCount = (nextCount) => {
        const safeCount = Number.isFinite(nextCount) && nextCount > 0 ? Math.max(0, Math.floor(nextCount)) : 0;
        cartBubble.hidden = safeCount === 0;
        cartCount.textContent = safeCount > 99 ? '99+' : String(safeCount);
      };

      document.addEventListener('cart:update', (event) => {
        const detail = event?.detail || {};
        const resourceCount = Number(detail.resource?.item_count);
        const updateCount = Number(detail.data?.itemCount);

        if (Number.isFinite(resourceCount)) {
          renderCartCount(resourceCount);
          return;
        }

        if (Number.isFinite(updateCount)) {
          const nextCount =
            detail.data?.source === 'product-form-component' ? getCurrentCount() + updateCount : updateCount;
          renderCartCount(nextCount);
        }
      });

      renderCartCount(getCurrentCount());
    }
  };

  const initQuoteSlider = (root) => {
    if (!root || root.dataset.tlInit === 'true') return;
    root.dataset.tlInit = 'true';

    const track = root.querySelector('[data-tl-quotes-track]');
    const slides = Array.from(root.querySelectorAll('[data-tl-quotes-slide]'));
    const indexLabel = root.querySelector('[data-tl-index]');
    if (!track || !slides.length) return;

    let index = 0;
    const total = slides.length;

    const render = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      if (indexLabel) indexLabel.textContent = `${index + 1}`;
    };

    root.querySelector('[data-tl-prev]')?.addEventListener('click', () => {
      index = (index - 1 + total) % total;
      render();
    });

    root.querySelector('[data-tl-next]')?.addEventListener('click', () => {
      index = (index + 1) % total;
      render();
    });

    render();
  };

  const initHero = (root) => {
    if (!root || root.dataset.tlHeroInit === 'true') return;
    root.dataset.tlHeroInit = 'true';

    const desktopMedia = root.querySelector('[data-tl-hero-media="desktop"]');
    const mobileMedia = root.querySelector('[data-tl-hero-media="mobile"]');
    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeMode = null;

    const teardown = (media) => {
      if (!media) return;
      const mount = media.querySelector('[data-tl-hero-video]');
      const video = mount?.querySelector('video');

      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.remove());
        try {
          video.load();
        } catch (_error) {
          // Ignore best-effort cleanup errors from older browsers.
        }
        video.remove();
      }

      media.classList.remove('is-ready', 'is-loading');
    };

    const mountVideo = (media) => {
      if (!media || reducedMotion) return;

      const mount = media.querySelector('[data-tl-hero-video]');
      const sourceUrl = media.dataset.tlVideoSrc;
      if (!mount || !sourceUrl || mount.querySelector('video')) return;

      const video = document.createElement('video');
      const source = document.createElement('source');

      source.src = sourceUrl;
      source.type = 'video/mp4';

      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('aria-hidden', 'true');
      video.appendChild(source);

      const markReady = () => {
        media.classList.add('is-ready');
        media.classList.remove('is-loading');
      };

      video.addEventListener('loadeddata', markReady, { once: true });
      video.addEventListener('canplay', markReady, { once: true });
      video.addEventListener('error', () => {
        media.classList.remove('is-loading');
      }, { once: true });

      mount.appendChild(video);
      media.classList.add('is-loading');

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          media.classList.remove('is-loading');
        });
      }
    };

    const syncHeroMedia = () => {
      const nextMode = desktopQuery.matches ? 'desktop' : 'mobile';
      if (nextMode === activeMode) return;
      activeMode = nextMode;

      if (nextMode === 'desktop') {
        teardown(mobileMedia);
        mountVideo(desktopMedia);
      } else {
        teardown(desktopMedia);
        mountVideo(mobileMedia);
      }
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', syncHeroMedia);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(syncHeroMedia);
    }

    syncHeroMedia();
  };

  const boot = () => {
    document.querySelectorAll('[data-tl-header]').forEach(initHeader);
    document.querySelectorAll('[data-tl-quote-slider]').forEach(initQuoteSlider);
    document.querySelectorAll('[data-tl-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
